export default {
  28878: {
    location: 'Colorado',
    modal: {
      title: 'Colorado state retail delivery fee',
      template: 'co-delivery-fee-modal',
    },
    text: 'CO retail delivery fee',
  },
  70000: {
    location: 'Minnesota',
    modal: {
      title: 'Minnesota road improvement and food delivery fee',
      template: 'mn-delivery-fee-modal',
    },
    text: 'MN road improvement and food delivery fee',
  },
}
